import { If, reactive } from 'cdui-js';
import i18n from '../../../../i18n';

export type ButtonSelectOption = {
  label: any;
  value: string | number;
};

export type ButtonSelectContentProps = {
  options: ButtonSelectOption[];
  initialValue: string;
  multiple?: boolean;
  onConfirm: (val: string) => void;
  close: () => void;
};

const toArr = (v: string): string[] =>
  v
    ? v
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

const optionLabel = (o: ButtonSelectOption) => (typeof o.label === 'function' ? o.label() : o.label);

/** ActionSheet 内按钮组选项：支持单选 / 多选 */
export const ButtonSelectContent = (panelProps: ButtonSelectContentProps) => {
  const state = reactive({
    selected: panelProps.multiple ? toArr(panelProps.initialValue) : toArr(panelProps.initialValue).slice(0, 1),
  });

  const isActive = (val: string) => state.selected.includes(val);

  const onTap = (val: string) => {
    if (panelProps.multiple) {
      if (isActive(val)) {
        state.selected = state.selected.filter((v) => v !== val);
      } else {
        state.selected = [...state.selected, val];
      }
      return;
    }
    // 单选：选中即回写并关闭
    panelProps.onConfirm(val);
    panelProps.close();
  };

  return (
    <div>
      <div class="f-select-box-btn-grid">
        {panelProps.options.map((o) => {
          const val = String(o.value);
          return (
            <div
              class={`f-select-box-btn${isActive(val) ? ' f-select-box-btn-active' : ''}`}
              onclick={() => onTap(val)}
            >
              {optionLabel(o)}
            </div>
          );
        })}
      </div>

      <If when={!!panelProps.multiple}>
        <div class="f-select-multi-actions">
          <div class="f-select-multi-btn f-select-multi-btn-cancel" onclick={panelProps.close}>
            {i18n.Common.Cancel}
          </div>
          <div
            class="f-select-multi-btn f-select-multi-btn-confirm"
            onclick={() => {
              panelProps.onConfirm(state.selected.join(','));
              panelProps.close();
            }}
          >
            {i18n.Common.Confirm}
          </div>
        </div>
      </If>
    </div>
  );
};
